export const COACH_OUTREACH_REPLIES_QUERY_KEY = [
  'admin',
  'coach-outreach-replies',
] as const;

const STORAGE_KEY = 'cp.admin.coach_outreach.replies_last_opened_at';

export const COACH_OUTREACH_REPLIES_OPENED_EVENT =
  'coach-outreach-replies-opened';

export type CoachOutreachReplyForUnread = {
  received_at: string | null;
};

export function getCoachOutreachRepliesLastOpenedAt(): string | null {
  if (typeof window === 'undefined') {
    return null;
  }
  return localStorage.getItem(STORAGE_KEY);
}

export function setCoachOutreachRepliesLastOpenedAt(
  at: string = new Date().toISOString(),
): void {
  if (typeof window === 'undefined') {
    return;
  }
  localStorage.setItem(STORAGE_KEY, at);
  window.dispatchEvent(
    new CustomEvent(COACH_OUTREACH_REPLIES_OPENED_EVENT, { detail: at }),
  );
}

export function countUnreadCoachOutreachReplies(
  replies: CoachOutreachReplyForUnread[],
  lastOpenedAt: string | null,
): number {
  if (!replies.length) {
    return 0;
  }

  const openedMs = lastOpenedAt ? Date.parse(lastOpenedAt) : Number.NaN;
  const hasValidOpenedAt = lastOpenedAt !== null && !Number.isNaN(openedMs);

  return replies.filter((reply) => {
    if (!reply.received_at) {
      return false;
    }
    const receivedMs = Date.parse(reply.received_at);
    if (Number.isNaN(receivedMs)) {
      return false;
    }
    if (!hasValidOpenedAt) {
      return true;
    }
    return receivedMs > openedMs;
  }).length;
}

export function hasUnreadCoachOutreachReplies(
  replies: CoachOutreachReplyForUnread[],
  lastOpenedAt: string | null,
): boolean {
  return countUnreadCoachOutreachReplies(replies, lastOpenedAt) > 0;
}
